/* eslint-disable react/prop-types */
import { useRef, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';

const NAVY_DARK = '#0f3460';

export default function VoiceInput({ onTranscript, disabled = false }) {
  const [recording, setRecording] = useState(false);
  const timeoutRef = useRef(null);
  const recognitionRef = useRef(null);

  const stopRecording = () => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    recognitionRef.current?.stop?.();
    recognitionRef.current = null;
    setRecording(false);
  };

  const start = () => {
    if (disabled || recording) {
      stopRecording();
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      onTranscript?.('', { error: 'Speech recognition is not supported in this browser.' });
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.continuous = false;
    recognitionRef.current = recognition;
    setRecording(true);

    recognition.onresult = (event) => {
      const text = event.results?.[0]?.[0]?.transcript || '';
      if (text.trim()) onTranscript(text.trim());
    };

    recognition.onerror = () => {
      stopRecording();
    };

    recognition.onend = () => {
      stopRecording();
    };

    recognition.start();
    timeoutRef.current = window.setTimeout(() => stopRecording(), 8000);
  };

  return (
    <Tooltip title={recording ? 'Listening… tap to stop' : 'Voice input'}>
      <span>
        <IconButton
          size="small"
          onClick={start}
          disabled={disabled}
          sx={{
            flexShrink: 0,
            width: 40,
            height: 40,
            borderRadius: 2,
            border: '1px solid',
            borderColor: recording ? 'error.light' : 'grey.200',
            bgcolor: recording ? 'error.50' : 'white',
            color: recording ? 'error.main' : 'grey.600',
            '&:hover': {
              borderColor: NAVY_DARK,
              color: NAVY_DARK,
              bgcolor: 'grey.50',
            },
          }}
        >
          {recording ? <MicOffIcon fontSize="small" /> : <MicIcon fontSize="small" />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
